import React, { useState } from 'react';
import ltoImage from './images/LTO.jpg';
import pfc from './images/pfcierd.jpg';
import rstw from './images/rstw.jpg';
import startup from './images/startup.jpg';
import tbi from './images/tbi.jpg';
import bicol from './images/bicol.jpg';
import riitd from './images/riitd.jpg';
import { Container, Row, Col, Card, Button, Badge, Form, InputGroup } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Slide from 'react-reveal/Slide';
import './styles/blogs.css';

const blogPosts = [
    {
        id: 1,
        title: "Exploring Potential Partnership with LTO-NCR",
        excerpt: "PASADA’s Project Leader, Dr. Felizardo Reyes Jr., formally introduced PASADA to LTO–NCR, presenting the project’s vision, key features, and potential areas for collaboration.",
        content: "The landscape of public transportation in the Philippines is rapidly evolving...",
        author: "Maria Santos",
        authorRole: "Transportation Expert",
        authorImage: "https://via.placeholder.com/60x60/667eea/ffffff?text=MS",
        date: "February 05, 2025",
        readTime: "5 min read",
        category: "Technology",
        tags: ["Innovation", "Transport", "Philippines"],
        image: ltoImage,
        featured: true
    },
    {
        id: 2,
        title: "PCIEERD GRAND MOA SIGNING",
        excerpt: "Today at the DOST-PCIEERD's Grand MOA signing, three of our FASTRAC Grantees (Spinoff Track) — Dr. Czar Jakiri Sarmiento of Project Lungsod, Dr. Felizardo Reyes Jr. of PASADA, and Engr. Denisse Pavia of AeroComp — shared their inspiring journeys from R&D to commercialization.",
        content: "Traffic congestion has been a persistent problem in Philippine cities...",
        author: "Juan Cruz",
        authorRole: "Data Analyst",
        authorImage: "https://via.placeholder.com/60x60/4facfe/ffffff?text=JC",
        date: "December 11, 2025",
        readTime: "7 min read",
        category: "Innovation",
        tags: ["Research", "Data", "Innovation"],
        image: pfc,
        featured: false
    },
    {
        id: 3,
        title: "Wrapped up PASADA's three-day showcase at RSTW-NCR 2025",
        excerpt: "Our sincere appreciation to DOST-NCR and the Technological Institute of the Philippines for giving PASADA the opportunity to showcase our innovation and to connect with students, government agencies, local offices, and other key partners in innovation.",
        content: "See you at our next events as we continue driving 𝘵𝘩𝘦 𝘯𝘦𝘹𝘵 𝘨𝘦𝘯𝘦𝘳𝘢𝘵𝘪𝘰𝘯 𝘰𝘧 𝘱𝘶𝘣𝘭𝘪𝘤 𝘵𝘳𝘢𝘯𝘴𝘱𝘰𝘳𝘵𝘢𝘵𝘪𝘰𝘯!",
        author: "Lisa Fernandez",
        authorRole: "Environmental Advocate",
        authorImage: "https://via.placeholder.com/60x60/38ef7d/ffffff?text=LF",
        date: "November 5, 2024",
        readTime: "6 min read",
        category: "Event",
        tags: ["Technology", "Innovation", "AI Showcase"],
        image: rstw,
        featured: false
    },
    {
        id: 4,
        title: "PH Startup Week 2025 — a week of ideas, impact, and community.",
        excerpt: "From inspiring keynotes to packed sessions, unexpected challenges to powerful comebacks, this year’s PHSW reminded us why the Filipino startup community is one of the most resilient in the world.",
        content: "Here’s to a bigger, bolder, and more unified Philippine startup ecosystem.",
        author: "Carlos Mendoza",
        authorRole: "Fintech Specialist",
        authorImage: "https://via.placeholder.com/60x60/764ba2/ffffff?text=CM",
        date: "November 14, 2025",
        readTime: "4 min read",
        category: "Event",
        tags: ["Technology", "Innovation", "AI Showcase"],
        image: startup,
        featured: false
    },
    {
        id: 5,
        title: "𝐃𝐫𝐢𝐯𝐢𝐧𝐠 𝐂𝐨𝐥𝐥𝐚𝐛𝐨𝐫𝐚𝐭𝐢𝐨𝐧 𝐅𝐨𝐫𝐰𝐚𝐫𝐝: 𝐏𝐀𝐒𝐀𝐃𝐀 𝐚𝐭 𝐭𝐡𝐞 𝐍𝐂𝐑 𝐓𝐁𝐈 𝐒𝐮𝐦𝐦𝐢𝐭 𝟐𝟎𝟐𝟓",
        excerpt: "PASADA joined the NCR TBI Summit 2025 at Makati Diamond Residences on October 22, 2025, a gathering that brought together innovators, researchers, and changemakers driving inclusive growth through technology. Representing PASADA at the summit were Project Implementation Officer Kim Sinchioco and Hardware Engineer Denzel Manalo.",
        content: "Together, we move closer to building the 𝙣𝙚𝙭𝙩 𝙜𝙚𝙣𝙚𝙧𝙖𝙩𝙞𝙤𝙣 𝙤𝙛 𝙥𝙪𝙗𝙡𝙞𝙘 𝙩𝙧𝙖𝙣𝙨𝙥𝙤𝙧𝙩𝙖𝙩𝙞𝙤𝙣",
        author: "Anna Rodriguez",
        authorRole: "Rural Development Expert",
        authorImage: "https://via.placeholder.com/60x60/ff6b6b/ffffff?text=AR",
        date: "October 24, 2025",
        readTime: "8 min read",
        category: "Event",
        tags: ["Technology", "Innovation", "AI Showcase"],
        image: tbi,
        featured: false
    },
    {
        id: 6,
        title: "Strenthening Partnerships and Driving Innovation Forward",
        excerpt: "Bicol Isarog Transport System Inc. and PASADA recently held a coordination meeting on October 7, 2025 to discuss the upcoming pilot test deployment of the PASADA Device. The meeting covered key topics such as the device’s functionality and reliability, trips and driver performance monitoring, clarification on data recording and violation tracking, and future integration plans.",
        content: "Together, we move closer to building the 𝙣𝙚𝙭𝙩 𝙜𝙚𝙣𝙚𝙧𝙖𝙩𝙞𝙤𝙣 𝙤𝙛 𝙥𝙪𝙗𝙡𝙞𝙘 𝙩𝙧𝙖𝙣𝙨𝙥𝙤𝙧𝙩𝙖𝙩𝙞𝙤𝙣 — data-driven, efficient, and safe for all.",
        author: "Michael Torres",
        authorRole: "Safety Engineer",
        authorImage: "https://via.placeholder.com/60x60/ffc107/ffffff?text=MT",
        date: "October 23, 2025",
        readTime: "5 min read",
        category: "Collaboration",
        tags: ["Technology", "Collaboration", "AI Showcase"],
        image: bicol,
        featured: false
    },
    {
        id: 7,
        title: "PCIEERD RITTD @ TechnoCoRe Plenary 2025!",
        excerpt: "A momentous event happened this morning in Technological Institute of the Philippines, aiming to unite the academe, industry, and government toward stronger collaboration for innovation and growth.",
        content: "One of the featured innovations was 𝐅𝐀𝐒𝐓𝐑𝐀𝐂 𝐏𝐀𝐒𝐀𝐃𝐀: 𝐏𝐔𝐕𝐬 𝐏𝐚𝐭𝐭𝐞𝐫𝐧𝐬 𝐚𝐧𝐝 𝐀𝐭𝐭𝐢𝐭𝐮𝐝𝐞 𝐨𝐧 𝐒𝐭𝐫𝐞𝐞𝐭𝐬 𝐮𝐬𝐢𝐧𝐠 𝐀𝐫𝐭𝐢𝐟𝐢𝐜𝐢𝐚𝐥 𝐈𝐧𝐭𝐞𝐥𝐥𝐢𝐠𝐞𝐧𝐜𝐞 𝐚𝐧𝐝 𝐃𝐚𝐭𝐚 𝐀𝐧𝐚𝐥𝐲𝐭𝐢𝐜𝐬, led by Dr. Felizardo Reyes Jr., Assistant VP of Academic Affairs. ",
        author: "Michael Torres",
        authorRole: "Safety Engineer",
        authorImage: "https://via.placeholder.com/60x60/ffc107/ffffff?text=MT",
        date: "August 15, 2025",
        readTime: "5 min read",
        category: "Event",
        tags: ["Technology", "Collaboration", "AI Showcase"],
        image: riitd,
        featured: false
    }
];

const categories = ["All", "Technology", "Case Study", "Sustainability", "Collaboration", "Event", "Innovation"];

const Blogs = () => {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [searchTerm, setSearchTerm] = useState("");

    const filteredPosts = blogPosts.filter(post => {
        const matchesCategory = selectedCategory === "All" || post.category === selectedCategory;
        const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            post.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
        return matchesCategory && matchesSearch;
    });

    const featuredPost = blogPosts.find(post => post.featured);
    const regularPosts = filteredPosts.filter(post => !post.featured);

    return (
        <div className="blogs-page">
            <Helmet>
                <title>Blogs - PASADA</title>
                <meta name="description" content="Read the latest insights, case studies, and updates from PASADA about transportation technology" />
                <link rel="canonical" href="/blogs" />
            </Helmet>

            {/* Hero Section */}
            <section className="blogs-hero">
                <Container>
                    <Row className="align-items-center min-vh-60">
                        <Col lg={8} md={10} className="mx-auto text-center">
                            <Slide bottom>
                                <h1 className="hero-title">Insights & Stories</h1>
                                <p className="hero-subtitle">
                                    Discover the latest developments in transportation technology, case studies, and insights from our experts
                                </p>
                            </Slide>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Search and Filter */}
            <section className="search-filter py-4 bg-light">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <Row className="align-items-center">
                                <Col md={6} className="mb-3 mb-md-0">
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search articles..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                        <InputGroup.Text className="search-icon">
                                            <i className="fas fa-search"></i>
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Col>
                                <Col md={6}>
                                    <div className="category-filters">
                                        {categories.map(category => (
                                            <Button
                                                key={category}
                                                variant={selectedCategory === category ? "primary" : "outline-primary"}
                                                size="sm"
                                                className="me-2 mb-2 category-btn"
                                                onClick={() => setSelectedCategory(category)}
                                            >
                                                {category}
                                            </Button>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Featured Post */}
            {featuredPost && selectedCategory === "All" && !searchTerm && (
                <section className="featured-post py-5">
                    <Container>
                        <Row>
                            <Col lg={10} className="mx-auto">
                                <Slide bottom>
                                    <Card className="featured-card shadow-lg">
                                        <Row className="g-0">
                                            <Col md={6}>
                                                <div className="featured-image-wrapper">
                                                    <img 
                                                        src={featuredPost.image} 
                                                        className="featured-image"
                                                        alt={featuredPost.title}
                                                        onError={(e) => {
                                                            e.target.src = "https://via.placeholder.com/400x250/cccccc/ffffff?text=Featured+Article";
                                                        }}
                                                    />
                                                    <Badge bg="warning" className="featured-badge">
                                                        Featured
                                                    </Badge>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <Card.Body className="d-flex flex-column h-100 p-4">
                                                    <Badge bg="outline-primary" className="category-badge mb-2 align-self-start">
                                                        {featuredPost.category}
                                                    </Badge>
                                                    <h2 className="featured-title mb-3">{featuredPost.title}</h2>
                                                    <p className="featured-excerpt mb-4">{featuredPost.excerpt}</p>
                                                    
                                                    <div className="post-meta mb-4">                                                
                                                        <div className="post-info">
                                                            <span className="post-date">{featuredPost.date}</span>
                                                            <span className="post-separator">•</span>
                                                            <span className="read-time">{featuredPost.readTime}</span>
                                                        </div>
                                                    </div>

                                                    <Button variant="primary" size="lg" className="mt-auto">
                                                        Read Full Article
                                                    </Button>
                                                </Card.Body>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Slide>
                            </Col>
                        </Row>
                    </Container>
                </section>
            )}

            {/* Blog Posts Grid */}
            <section className="blog-posts py-5">
                <Container>
                    <Row>
                        {regularPosts.map((post, index) => (
                            <Col lg={4} md={6} className="mb-4" key={post.id}>
                                <Slide bottom delay={index * 100}>
                                    <Card className="blog-card h-100 shadow-sm">
                                        <div className="blog-image-wrapper">
                                            <img 
                                                src={post.image} 
                                                className="blog-image"
                                                alt={post.title}
                                                onError={(e) => {
                                                    e.target.src = "https://via.placeholder.com/400x250/cccccc/ffffff?text=Blog+Image";
                                                }}
                                            />
                                        </div>
                                        <Card.Body className="d-flex flex-column">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <Badge bg="outline-primary" className="category-badge">
                                                    {post.category}
                                                </Badge>
                                                <small className="text-muted">{post.readTime}</small>
                                            </div>
                                            
                                            <Card.Title className="blog-title mb-2">{post.title}</Card.Title>
                                            <Card.Text className="blog-excerpt">{post.excerpt}</Card.Text>
                                            
                                            <div className="blog-tags mb-3">
                                                {post.tags.map(tag => (
                                                    <Badge key={tag} bg="light" text="dark" className="me-1 mb-1 tag-badge">
                                                        {tag}
                                                    </Badge>
                                                ))}
                                            </div>

                                            <div className="mt-auto">
                                                <div className="d-flex justify-content-between align-items-center">                                                
                                                    <small className="text-muted">{post.date}</small>
                                                </div>
                                                <Button variant="outline-primary" className="w-100 mt-3 blog-btn">
                                                    Read More
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Slide>
                            </Col>
                        ))}
                    </Row>
                    
                    {filteredPosts.length === 0 && (
                        <Row>
                            <Col className="text-center py-5">
                                <h4>No articles found</h4>
                                <p className="text-muted">Try adjusting your search terms or category filter.</p>
                            </Col>
                        </Row>
                    )}
                </Container>
            </section>

            {/* Newsletter Section */}
            <section className="newsletter-section py-5 bg-primary text-white">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <Slide bottom>
                                <h2>Stay Updated</h2>
                                <p className="lead mb-4">
                                    Subscribe to our newsletter for the latest insights and updates from the world of transportation technology.
                                </p>
                                <Form className="newsletter-form">
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email address"
                                            className="newsletter-input"
                                        />
                                        <Button variant="light" className="newsletter-btn">
                                            Subscribe
                                        </Button>
                                    </InputGroup>
                                </Form>
                            </Slide>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default Blogs;